import ImportedPatient from 'models/ImportedPatient';

import CoordinateListItem from './CoordinateListItem';

function PatientList({
  patients,
  onAddToPortfolio,
}: {
  patients: ImportedPatient[];
  onAddToPortfolio?: (value: string) => void;
}) {
  return (
    <>
      {patients.map((patient) => (
        <CoordinateListItem
          key={patient.id}
          hospital={patient.transferredFrom?.name ?? ''}
          onAddToPortfolio={onAddToPortfolio}
          {...patient}
        />
      ))}
    </>
  );
}

export default PatientList;
